import React, { useEffect, useRef } from 'react';

import { ResultValue } from '../DiceResult/DiceResult.styles';

export default ({children, title, expression}) => {

    const element = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            element.current.classList.add('show');
        }, 3000);
    }, []);

    return <ResultValue ref={element} title={`(${expression || ''}): ${title || ''}`}>{children}</ResultValue>;
};